import { getSessionStore } from "app/utils/sessionStore";
import ThreadsContainer from "../../PremiumFinanceThreads/ThreadsContainer";
import { useEffect, useState } from "react";
import { usePermission } from "app/hooks/usePermission";
import { canEditPermission } from "app/zustand/assistantPermissionsStore";

function ThreadsIntRev() {
  const planId = getSessionStore("planInfo")?.planId;
  const [selectedYear, setSelectedYear] = useState<number>(getSessionStore("ircSelectedYear") ?? 1);

  const { level: plansPermissionLevel } = usePermission("PORTFOLIO.PLANS");
  const canEditPlans = canEditPermission(plansPermissionLevel);

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail ?? {};
      if (detail.year !== undefined) {
        setSelectedYear(detail.year);
      }
    };
    window.addEventListener("ircSelectionChanged", handler);
    return () => window.removeEventListener("ircSelectionChanged", handler);
  }, []);

  return (
    <div>
      <ThreadsContainer
        proposalId={planId ?? ""}
        isPlan
        threadType="REVIEW"
        selectedYear={selectedYear}
        hidePostComposer={!canEditPlans}
      />
    </div>
  );
}
export default ThreadsIntRev;
